import { Banner, Page, SelectFilter } from '@/components';
import { Heading, Flex, useTableProps, Box } from '@blockanalitica/ui';
import ParametersTable from './ParametersTable';
import AuctionParametersTable from './AuctionParametersTable';
import ParametersChangesTable from './ChangesTable';
import { useMemo } from 'react';
import { ILK_PARAMETERS } from '@/constants';

export default function ParametersSummary() {
  const { filters } = useTableProps();

  const selectFilterOptions = useMemo(() => {
    const options = [{ label: 'All parameters', value: '' }];
    options.push(
      ...Object.entries(ILK_PARAMETERS).map(([key, value]) => ({
        label: value,
        value: key,
        selected: key === filters.filtersApplied.parameter
      }))
    );
    return options;
  }, [filters]);

  return (
    <Page title={<Heading size="1">Parameters</Heading>}>
      <Banner>
        <Box paddingTop="xs" paddingBottom="m" maxWidth="85%">
          <Heading size="2">About the Sky Protocol Vault Parameters</Heading>
          <br />
          Stay updated on real-time risk, debt ceilings, and auction settings
          across collateral types and allocators. Monitor system health,
          stability fees, and recent governance parameter changes.
        </Box>
      </Banner>
      <ParametersTable />
      <Heading size="2">Auction Parameters</Heading>
      <AuctionParametersTable />

      <Flex
        flexDirection="row"
        justifyContent="space-between"
        alignContent="center"
        alignItems="center">
        <Heading size="2">Parameters Changes</Heading>
        <SelectFilter
          key="parameter-filter"
          filterField="parameter"
          options={selectFilterOptions}
          {...filters}
        />
      </Flex>
      <ParametersChangesTable parameter={filters.filtersApplied.parameter} />
    </Page>
  );
}
